<template>
	<nav class="navbar navbar-expand-lg sticky-top navbar-light bg-white border-bottom">
		<div class="container-fluid">
            <dot-incorporation-logo/>
			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu, #navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<ul class="navbar-nav me-auto mb-2">
				</ul>
				<div class="d-flex justify-content-end">
					<button class="nav-link gap-3 d-flex border-0 bg-white" @click="signOut()">
						Sign out
					</button>
				</div>
			</div>
		</div>
	</nav>
	<div class="container-fluid">
		<div class="row">
			<!-- <div class= "col-sm-2"> -->
			<nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-white collapse">
				<div class="position-sticky">
					<LeftMenu></LeftMenu>
				</div>
			</nav>
            <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <router-view />
            </main>
			<footer class="d-grid bg-light d-flex justify-content-center p-3 mt-4 sticky-bottom text-center">
				Copyright©2022 Dot Incorporation. All rights reserved. Terms&Condition Privacy Policy
			</footer>
		</div>
	</div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import LeftMenu from "./LeftMenu";
import { $global, $session } from "@/dot-ui/index.js";
import { router } from "@/router/index.js";

const DotIncorporationLogo = defineAsyncComponent(() =>
    import("@/components/molecules/DotIncorporationLogo.vue")
);

export default {
  components: {
    DotIncorporationLogo,
    LeftMenu,
  },
  methods: {
    async signOut() {
      await $session.signOut();

      const fromParams = $global.getUrlParams();

      router.push({
        path: "/login",
        query: {
          cb: fromParams.cb,
          s: fromParams.s,
          c: fromParams.c,
        },
      });
    },

    goMain() {
      const fromParams = $global.getUrlParams();
      router.push({
        path: "/",
        query: {
          cb: fromParams.cb,
          s: fromParams.s,
          c: fromParams.c,
        },
      });
    },
  },
};
</script>
<style>
.nav-link {
  color: black;
}
.nav-link:hover{
	color: black;
	background-color: rgb(235, 235, 235);
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
	background-color: black;
}
.nav-link:focus{
	background-color: rgb(199, 199, 199);
}
</style>
